import {createStyles, Theme} from '@material-ui/core';

const styles = createStyles((theme: Theme) => ({
    popper: {
        '& .MuiTooltip-tooltip': {
            whiteSpace: 'pre-line',
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            boxShadow: theme.shadows[1],
            padding: theme.spacing(4),
            minWidth: '360px',
        },
        '& .MuiTooltip-arrow::before': {
            backgroundColor: theme.palette.common.white,
        },
    },
}));

export default styles;
